import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import ReceiptItemRow from './ReceiptItemRow'
import Card from './Card'
import {
  BookingSummaryWrapper,
  TotalCost,
  TotalCostLabel,
  TotalCostValue,
  VatInfoRow,
  TotalCostValuesWrapper,
  TotalCostSecondaryValue,
  TouristTaxRow,
  ReceiptItemWrapper,
  ReceiptItems,
  TouristTaxAmount
} from './style'
import { formatPrice } from 'Rentlio/components/utils/Price/price'
import { LanguageContext } from 'Rentlio/context/LanguageContext'
import { CurrenciesContext } from 'Rentlio/context/CurrenciesContext'
import { shouldShowHrkTotal } from 'Rentlio/helper/currency'

class BookingSummary extends React.Component {
  static contextType = LanguageContext
  render() {
    const {
      receipt,
      showCard,
      cardHolderName,
      maskedPan,
      selectedPaymentMethod,
      createdAt,
      showPricePerDayModal,
      bookingEngine
    } = this.props
    const { items, taxes } = receipt
    const { translate } = this.context

    const earliestArrivalDate = items.reduce((acc, { arrival }) => {
      if (acc === null) return arrival
      if (arrival.isBefore(acc)) return arrival
      return acc
    }, null)

    return (
      <CurrenciesContext.Consumer>
        {({ currencyConversion }) => {
          const { value: totalBookingCost, currency: totalBookingCostCurrency } = currencyConversion(
            receipt.totalBookingCost,
            receipt.currency
          )

          return (
            <BookingSummaryWrapper>
              <ReceiptItems>
                {items.map((item, i) => (
                  <ReceiptItemWrapper key={i}>
                    <ReceiptItemRow
                      showPricePerDayModal={showPricePerDayModal}
                      index={i}
                      item={item}
                      selectedPaymentMethod={selectedPaymentMethod}
                      createdAt={createdAt}
                      earliestArrivalDate={earliestArrivalDate}
                    />
                    {item.isTouristTaxIncluded || item.excludedTouristTaxAmount ? (
                      <TouristTaxRow>
                        <div>
                          {translate(
                            item.isTouristTaxIncluded
                              ? 'Tourist tax is included in price'
                              : 'Tourist tax is not included in total and is paid at property'
                          )}
                        </div>
                        {item.excludedTouristTaxAmount ? (
                          <TouristTaxAmount>
                            {formatPrice(currencyConversion(item.excludedTouristTaxAmount, receipt.currency).value)}{' '}
                            {totalBookingCostCurrency}
                          </TouristTaxAmount>
                        ) : null}
                      </TouristTaxRow>
                    ) : null}
                  </ReceiptItemWrapper>
                ))}
              </ReceiptItems>
              <TotalCost>
                <TotalCostLabel>{translate('Total cost')}</TotalCostLabel>
                <TotalCostValuesWrapper>
                  <TotalCostValue>
                    {formatPrice(totalBookingCost)} {totalBookingCostCurrency}
                  </TotalCostValue>
                  {shouldShowHrkTotal(receipt.currency) && (
                    <TotalCostSecondaryValue>
                      {formatPrice(receipt.totalBookingCost * (bookingEngine?.settingsExchangeRate || 1))} {'HRK'}
                    </TotalCostSecondaryValue>
                  )}
                </TotalCostValuesWrapper>
              </TotalCost>
              {receipt.isVatRegistered &&
                taxes.map(tax => {
                  return (
                    <VatInfoRow key={tax.label}>
                      <div>
                        {tax.label} ({tax.rate}%) {translate('included in price')}
                      </div>
                    </VatInfoRow>
                  )
                })}
              {!receipt.isVatRegistered && (
                <VatInfoRow>
                  <div>{translate('Property is not VAT registered, so VAT is not applicable')}</div>
                </VatInfoRow>
              )}
              {totalBookingCostCurrency !== receipt.currency && (
                <VatInfoRow>
                  <div>
                    {translate('CurrencyDisplayOnlyNotice', {
                      '%displayCurrency%': totalBookingCostCurrency,
                      '%chargeCurrency%': receipt.currency
                    })}
                  </div>
                </VatInfoRow>
              )}
              {showCard && <Card cardHolderName={cardHolderName} maskedPan={maskedPan} />}
            </BookingSummaryWrapper>
          )
        }}
      </CurrenciesContext.Consumer>
    )
  }
}

BookingSummary.propTypes = {
  receipt: PropTypes.object,
  hasTitle: PropTypes.bool,
  showCard: PropTypes.bool,
  cardHolderName: PropTypes.string,
  maskedPan: PropTypes.string,
  selectedPaymentMethod: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  createdAt: PropTypes.number,
  showPricePerDayModal: PropTypes.func,
  bookingEngine: PropTypes.object
}

BookingSummary.defaultProps = {
  showCard: false
}

export default BookingSummary
